import Iconify from "@/components/ui/Iconify";
import { Masonry } from "@/components/ui/mui-lab-replacements";
import StaticVideoPreview from "@/components/ui/StaticVideoPreview";
import { Box } from "@mui/material";
import Image from "next/image";
import { getMediaRecordPath, getMediaRecordUrl } from "@/utils/media";

const PDW_PlaceTabPicturesSection = ({
  placeMedia,
  isCssForDialog,
  openPlaceMediaSlider,
}) => {
  const renderPictureMedia = (media) => {
    const mediaUrl = getMediaRecordUrl(media);
    const imageUrl =
      getMediaRecordUrl(media, { variant: "thumbnail" }) ||
      mediaUrl ||
      "/person.png";
    const posterUrl =
      media?.thumbnailPath || media?.placeholderPath || media?.placeholder
        ? getMediaRecordUrl(media, { variant: "thumbnail" })
        : undefined;

    if (media?.mediaType?.includes("video")) {
      return (
        <StaticVideoPreview
          src={mediaUrl}
          poster={posterUrl}
          className="object-cover w-full h-full"
        />
      );
    } else {
      return (
        <Image
          src={imageUrl}
          alt="sample"
          width={640}
          height={640}
          sizes={
            isCssForDialog
              ? "(max-width: 640px) 100vw, 33vw"
              : "(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 16vw"
          }
          quality={90}
          className="w-full h-full object-cover"
        />
      );
    }
  };

  const handleMediaClick = (index) => {
    openPlaceMediaSlider(
      placeMedia?.map((pm) => getMediaRecordPath(pm)),
      index
    );
  };
  return (
    <div className="w-full min-h-[80vh]">
      {placeMedia?.length > 0 ? (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            pb: 5,
          }}
        >
          <Masonry
            columns={
              isCssForDialog
                ? { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }
                : { xs: 2, sm: 4, md: 4, lg: 8, xl: 8 }
            }
          >
            {placeMedia.map((_pm, index) => {
              return (
                <div
                  key={index}
                  className={`relative ${
                    !isCssForDialog && "w-full"
                  } rounded-lg border dark:border-brown overflow-hidden min-h-[100px] h-auto`}
                  onClick={() => handleMediaClick(index)}
                >
                  <div className="absolute top-0 left-0 w-full h-full bg-black/0 hover:bg-black/20 transition ease-in-out duration-300 z-10 cursor-pointer" />
                  {_pm?.mediaType?.includes("video") && (
                    <div className="absolute top-2 right-2 w-5 h-5 bg-black/10 backdrop-blur rounded-full z-10">
                      <Iconify
                        icon={"mynaui:play-solid"}
                        className={"!text-white"}
                      />
                    </div>
                  )}
                  {renderPictureMedia(_pm)}
                </div>
              );
            })}
          </Masonry>
        </Box>
      ) : (
        <div className="flex flex-col gap-2 items-center justify-center h-[300px]">
          <Image
            src={"/no-data.png"}
            alt="no-data"
            width={50}
            height={50}
            className="object-contain"
          />
          <span className="text-xs text-black/30 dark:text-white/30">
            사용 가능한 사진이 없습니다.
          </span>
        </div>
      )}
    </div>
  );
};

export default PDW_PlaceTabPicturesSection;
